import { render } from "./SubstudyEditInfoForm.vue?vue&type=template&id=3a67fea3"
import script from "./SubstudyEditInfoForm.vue?vue&type=script&lang=js"
export * from "./SubstudyEditInfoForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__